import '~/instrument.ts';
import 'normalize.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '~/App';
import { errorHandlers } from '~/monitoring.ts';

window.IS_PRODUCTION = import.meta.env.MODE === 'production';

const rootElement = document.getElementById('root')!;
rootElement.classList.add('RemotelyTheme'); // Add class to root element for styling

const root = createRoot(rootElement, {
    ...errorHandlers,
});

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
